<template>
  <v-dialog
    :value="value"
    content-class="sso-retire-confirm-dialog"
    persistent
    data-testid="sso-retire-confirm-dialog"
    @input="$emit('input', $event)"
  >
    <v-card :loading="loading" :disabled="loading" loader-height="2">
      <div
        class="sso-retire-confirm-dialog__header primary white--text d-flex align-center px-4"
        data-testid="sso-retire-confirm-dialog__header"
      >
        <span class="subtitle-1 white--text" data-testid="sso-retire-confirm-dialog__title">
          {{ title }}
        </span>
        <v-spacer />
        <v-btn
          icon
          class="white--text"
          :disabled="loading"
          data-testid="sso-retire-confirm-dialog__close"
          @click="$emit('input', false)"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
      <v-card-text class="pt-4" data-testid="sso-retire-confirm-dialog__body">
        <div class="mb-3 body-2">
          {{ message || 'This action cannot be undone easily. Provide a reason to continue.' }}
        </div>
        <v-textarea
          v-model="localReason"
          label="Reason*"
          outlined
          dense
          rows="3"
          hide-details="auto"
          :error-messages="reasonError"
          data-testid="sso-retire-confirm-dialog__reason"
        />
        <v-text-field
          v-if="showReserveDays"
          v-model.number="localReserveDays"
          class="mt-3"
          type="number"
          min="0"
          label="Reserve days"
          outlined
          dense
          hide-details="auto"
          :error-messages="reserveDaysError"
          data-testid="sso-retire-confirm-dialog__reserve-days"
        />
      </v-card-text>
      <v-card-actions class="px-4 pb-4">
        <v-spacer />
        <v-btn
          text
          :disabled="loading"
          data-testid="sso-retire-confirm-dialog__cancel"
          @click="$emit('input', false)"
        >
          Cancel
        </v-btn>
        <v-btn
          color="error"
          class="white--text"
          :loading="loading"
          data-testid="sso-retire-confirm-dialog__confirm"
          @click="confirm"
        >
          Confirm
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'RetireConfirmDialog',
  props: {
    value: { type: Boolean, default: false },
    title: { type: String, default: 'Retire' },
    message: { type: String, default: '' },
    loading: { type: Boolean, default: false },
    showReserveDays: { type: Boolean, default: false },
    defaultReserveDays: { type: Number, default: 90 },
  },
  data() {
    return {
      localReason: '',
      localReserveDays: this.defaultReserveDays,
      reasonError: '',
      reserveDaysError: '',
    };
  },
  watch: {
    value(open) {
      if (open) {
        this.localReason = '';
        this.localReserveDays = this.defaultReserveDays;
        this.reasonError = '';
        this.reserveDaysError = '';
      }
    },
  },
  methods: {
    confirm() {
      const reason = String(this.localReason || '').trim();
      if (!reason) {
        this.reasonError = 'Reason is required';
        return;
      }
      this.reasonError = '';
      this.reserveDaysError = '';

      let reserveDays;
      if (this.showReserveDays) {
        const parsed = Number(this.localReserveDays);
        if (Number.isFinite(parsed) && parsed < 0) {
          this.reserveDaysError = 'Reserve days cannot be negative';
          return;
        }
        reserveDays = Math.max(0, Number.isFinite(parsed) ? parsed : 0);
      }

      this.$emit('confirm', {
        reason,
        reserveDays,
        confirm: true,
      });
    },
  },
};
</script>

<style lang="scss">
@import './RetireConfirmDialog.scss';
</style>
